import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsFavoriteEvent,
  selectFavoriteVideoIdForEvent,
} from '../../store/player_favorites/favoritesSlice';
import {
  addEventToFavorites,
  removeEventFromFavorites,
} from '../../store/player_favorites/favoritesService';

// Star toggle for an event row — adds/removes from the permanent Favorites
// playlist. Click events are stopped so taps don't accidentally toggle the
// row checkbox or follow a wrapping <label>.
const FavoriteToggle = ({ event }) => {
  const dispatch = useDispatch();
  const eventId = event?.markerId ?? event?.eventId ?? event?.id;
  const isFav = useSelector((state) => selectIsFavoriteEvent(state, eventId));
  const videoId = useSelector((state) => selectFavoriteVideoIdForEvent(state, eventId));

  const onClick = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isFav && videoId) {
      dispatch(removeEventFromFavorites({ videoId }));
    } else if (!isFav && eventId != null) {
      dispatch(addEventToFavorites({
        markerId: eventId,
        paramName: event?.paramName,
      }));
    }
  }, [dispatch, eventId, event, isFav, videoId]);

  if (eventId == null) return null;

  return (
    <Btn
      type="button"
      $active={isFav}
      aria-label={isFav ? 'Remove from favorites' : 'Add to favorites'}
      aria-pressed={isFav}
      onClick={onClick}
    >
      <Star $active={isFav} viewBox="0 0 24 24" width="18" height="18">
        <path d="M12 2.5 14.9 9 22 9.9 16.8 14.7 18.2 22 12 18.4 5.8 22 7.2 14.7 2 9.9 9.1 9 12 2.5Z" />
      </Star>
    </Btn>
  );
};

export default FavoriteToggle;

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: 0;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  flex-shrink: 0;
  transition: transform 80ms ease;

  &:hover { background: rgba(255, 255, 255, 0.04); }
  &:active { transform: scale(0.92); }
`;

const Star = styled.svg`
  fill: ${(props) => (props.$active ? props.theme.green : 'transparent')};
  stroke: ${(props) => (props.$active ? props.theme.green : props.theme.blueish2)};
  stroke-width: 1.5;
  stroke-linejoin: round;
  transition: fill 120ms ease, stroke 120ms ease;
`;
